// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"5a3ff23b","896":"46f70b36"}[chunkId] + ".chunk.css";
};